const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: '生活照顧',
      description: '專業照服員提供日常生活協助，包含用餐、如廁、清潔等貼心服務',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/1d57dfc92735a41c6074c74ea4925d40.jpeg',
      alt: '高雄前金日照中心生活照顧服務 - 專業照服員協助長者日常生活',
    },
    {
      icon: 'ri-run-line',
      title: '健康促進',
      description: '規劃體適能運動課程，維持長者身體機能與活動力',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/80a9c1d6ddcc756f0b83d0505eb0e9e9.jpeg',
      alt: '前金日照中心健康促進活動 - 長者體適能運動課程',
    },
    {
      icon: 'ri-brain-line',
      title: '認知訓練',
      description: '透過益智遊戲與活動，延緩認知功能退化',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/ae77f4c5a340446a89dbd0d4bf90890d.jpeg',
      alt: '高雄前金日照認知訓練課程 - 長者益智遊戲活動',
    },
    {
      icon: 'ri-group-line',
      title: '社交互動',
      description: '豐富的團體活動，促進長者間的交流與情感連結',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/cc91792f6068e6756261c4d1994ba1e0.jpeg',
      alt: '前金日照中心社交互動活動 - 長者團體交流活動',
    },
    {
      icon: 'ri-car-line',
      title: '交通接送',
      description: '提供安全舒適的交通接送服務，解決家屬接送困擾',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/df2f903b9e55c9ef743c3531222da3ed.jpeg',
      alt: '高雄前金日照交通接送服務 - 無障礙接送車輛',
    },
    {
      icon: 'ri-parent-line',
      title: '家屬支持',
      description: '定期舉辦家屬座談會，提供照護諮詢與情感支持',
      image: 'https://static.readdy.ai/image/e6fb9fe30ffa661384912f3cccf551e7/dcfbadd464118ab435d69190ff401e84.jpeg',
      alt: '前金日照中心家屬支持服務 - 照護諮詢與座談會',
    },
  ];

  return (
    <section id="services" className="py-24 bg-white" aria-labelledby="services-title">
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-cream-100 px-4 py-2 rounded-full mb-6">
            <i className="ri-service-line text-cream-500" aria-hidden="true"></i>
            <span className="text-sm font-medium text-baby-blue-600">服務項目</span>
          </div>

          <h2 id="services-title" className="text-3xl md:text-4xl font-bold text-baby-blue-600 mb-4">
            <a href="#services" className="hover:text-baby-blue-700 transition-colors">高雄市前金區日照中心專業服務</a>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            提供<strong>長照3.0</strong>完整服務方案，<strong>高雄市前金日照推薦</strong>專業團隊用心照護每一位長者
          </p>
        </header>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article
              key={index}
              className={`group rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-xl ${
                service.color === 'baby-blue' ? 'bg-baby-blue-50' : 'bg-cream-100'
              }`}
            >
              <figure className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.alt}
                  title={`${service.title} - 前金日間照顧中心專業服務`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className={`absolute top-4 left-4 w-12 h-12 flex items-center justify-center rounded-xl ${
                  service.color === 'baby-blue' ? 'bg-baby-blue-300' : 'bg-cream-300'
                }`}>
                  <i className={`${service.icon} text-white text-xl`} aria-hidden="true"></i>
                </div>
              </figure>

              <div className="p-6">
                <h3 className="text-xl font-bold text-baby-blue-600 mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;